import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventManagementRoutingModule } from './event-management-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LucideAngularModule, icons } from 'lucide-angular';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ElementsModule } from 'src/app/shared/elements/elements.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { Interceptor } from 'src/app/services/interceptor/interceptor.interceptor';
import { EventComponent } from './event/event.component';
import { SpeakerComponent } from './speaker/speaker.component';


@NgModule({
  declarations: [
    EventComponent,
    SpeakerComponent
  ],
  imports: [
    CommonModule,
    EventManagementRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    ElementsModule,
    LucideAngularModule.pick(icons),
    SlickCarouselModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    }
  ],
})
export class EventManagementModule { }
